import { MouseEvent, KeyboardEvent } from 'react';

export const animationClassNames = 'transition-all duration-200 ease-in-out';

export const handleClick = (event: MouseEvent, fn: () => void) => {
  event.preventDefault();
  event.stopPropagation();
  fn();
};

export const handleKeyDown = (event: KeyboardEvent, fn: () => void) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    event.stopPropagation();
    fn();
  }
};
